module.exports = __webpack_public_path__ + "img/lng.62838bbb.png";